import { useCallback, useState } from 'react';
import { RequestInput } from '../types';
import { APIRequests, MakeRequest } from '../config/legacyapi';

export enum APIStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export default function useLegacyAPI<T>(request: APIRequests): {
  data: T;
  execute: (input: RequestInput) => Promise<void>;
} {
  let temp: unknown;
  const [data, setData] = useState<T>(temp as T);

  const execute = useCallback(async (input: RequestInput) => {
    const req = MakeRequest(request, input);

    return fetch(req)
      .then(async (res) => {
        if (!res.ok) {
          const err = await res.json();
          throw err;
        }
        return res;
      })
      .then((res) => {
        return res
          .json()
          .then((json) => json)
          .catch(() => {
            return {};
          });
      })
      .then((result) => {
        if (result.data.record) {
          setData(result.data.record);
        } else if (result.data.records) {
          setData(result.data.records);
        } else {
          if ('data' in result) {
            setData(result.data);
          }
          console.log(request);
          console.log(result);
        }
      })
      .catch((error: Error) => {
        console.error('API Error:', error);
      });
  }, []);

  return { data, execute };
}
